import { call, take, put }    from 'redux-saga/effects';
import axios                  from 'axios';
import { CHANGE_MODAL_STATE } from '../actions';
import { DateTime, Interval } from 'luxon';

const now = DateTime.local();

const endpoint = 'https://www.yisumatica.org.il/yisumaticaApi/getWhatsappReminderStatus.php';


function* getTotalLikes(): Generator<any,any,any> {
  while(true) {
    try {

        const input = yield take('GET_WHATSAPP_STATUS_SAGA');

        const userEmail = input.payload;
        
        if (process.env.NODE_ENV === 'development') {  

          console.log('GET_WHATSAPP_STATUS_SAGA')

          //yield put(CHANGE_MODAL_STATE('whatsappRegistration'))

        }
        if (process.env.NODE_ENV === 'production') {

            const res = yield call( axios.post, endpoint, { userEmail: userEmail });

            if ( res && res.data && res.data.result && res.data.result.length ) {

              const { whatsapp_reminder, continue_whatsapp_reminder } = res.data.result[0];

              if (continue_whatsapp_reminder === 'true' ) {
                  if ( whatsapp_reminder.length > 0 ) {
                    const reminderDate = DateTime.fromISO(whatsapp_reminder);
                    const int_         = Interval.fromDateTimes(reminderDate, now).count('days');
                    if ( !isNaN(int_) && int_ >= 7 ) {
                       yield put(CHANGE_MODAL_STATE('whatsappRegistration'))
                    }
                  }
                  else {
                    yield put(CHANGE_MODAL_STATE('whatsappRegistration'))
                  }
              }
            }           

          }
        
    }
    catch(err) {
      console.log('err  :  '+err);
    }
    finally {}
  }
}


export default getTotalLikes;






